__webpack_require__.p = "/brmanager/";